/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../privacyvault/annotations';
import '../common/countries';
import '../common/currency_codes';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bank_accounts": {
        "nested": {
          "BankAccountType": {
            "values": {
              "UNKNOWN": 0,
              "CHECKING": 1,
              "SAVINGS": 2,
              "INVESTMENT": 3,
              "OTHER": 4,
              "BUSINESS_CHECKING": 5,
              "LOAN": 6,
              "LEDGER": 7
            }
          },
          "SquareBankAccount": {
            "values": {
              "CHASE_PLATFORM": 1,
              "CHASE_CAPITAL": 2,
              "CHASE_COMMERCIAL_ENTITY": 3,
              "CHASE_POLITICAL": 4,
              "CHASE_GIFT_CARDS_FBO": 5,
              "WELLS_PLATFORM": 6,
              "WELLS_CASH": 7,
              "WELLS_PAYROLL_EMPLOYEES": 8,
              "WELLS_PAYROLL_TAX": 9,
              "CHASE_SUBSCRIPTION": 10,
              "CHASE_CAPITAL_TRUST": 11,
              "WELLS_CASH_SETTLEMENTS": 12,
              "CELTIC_PLATFORM": 13,
              "WELLS_CASH_DEBITS": 14,
              "GBP_FPS_BARCLAYS_PLATFORM": 15,
              "AU_CHASE_PLATFORM": 16,
              "CA_CHASE_PLATFORM": 17,
              "FR_BARCLAYS_PLATFORM": 18,
              "JP_MIZUHO_PLATFORM": 19,
              "JP_SMBC_PLATFORM_DAILY": 20,
              "JP_SMBC_PLATFORM_WEEKLY": 21,
              "GBP_BARCLAYS_SAFEGUARD": 22,
              "WELLS_PAYROLL_OPERATING": 23,
              "TEST_PLATFORM": 24,
              "GBP_BARCLAYS_CASH": 25,
              "CA_CHASE_PAYROLL": 26,
              "WELLS_CAVIAR": 27,
              "WELLS_COMMERCIAL_ENTITY": 28,
              "CA_CHASE_COMMERCIAL_ENTITY": 29,
              "WELLS_TEST_PLATFORM": 30,
              "WELLS_CASH_BOOST": 31,
              "WELLS_BIZBANK_REWARDS": 32,
              "PR_CHASE_PLATFORM": 33,
              "VI_CHASE_PLATFORM": 34,
              "GBP_FPS_FORM3_STAGING": 35,
              "WELLS_MARKETPLACE_MTL": 36,
              "WELLS_CASH_ATM": 37,
              "CELTIC_FBO_CAPITAL": 38,
              "GBP_FPS_FORM3_ID_PLATFORM": 39,
              "WELLS_BIZBANK_PAYIN": 40,
              "AU_CHASE_CAPITAL": 41,
              "CHASE_RTP": 42,
              "CHASE_RTP_STAGING": 43,
              "WELLS_CASH_CHECK": 44,
              "CELTIC_CAPITAL_PPP": 45,
              "WELLS_CASH_LENDING": 46,
              "GBP_FPS_FORM3_BOE_STAGING": 47,
              "GBP_FPS_FORM3_BOE": 48,
              "SFS_PLATFORM": 49,
              "SFS_MPO_REPAYMENT": 50,
              "SFS_LOAN_SALES": 51,
              "CHASE_SFS_LOCKBOX": 52,
              "CHASE_SFS_OPERATING": 53,
              "CHASE_SFS_TRUST": 54,
              "EUR_BARCLAYS_PLATFORM": 55,
              "WELLS_CASH_PWC_FBO": 56,
              "WELLS_CASH_PWC_MARKETING": 57,
              "WELLS_CASH_PWC_REVENUE": 58,
              "WELLS_CASH_INSTANT_PAYCHECK": 59,
              "WELLS_ACH_ACCEPTANCE": 60,
              "CA_CHASE_CAPITAL": 61,
              "EUR_BARCLAYS_CASH": 62,
              "WELLS_CASH_PAPER_MONEY_DEPOSIT": 63,
              "WELLS_CASH_WIRE_INFLOW": 64,
              "AU_CUSCAL_NPP": 65,
              "GBP_BARCLAYS_CAPITAL": 66,
              "WELLS_CASH_BILL_PAY": 67,
              "CA_CHASE_CASH": 68,
              "CHASE_CAPITAL_AFTERPAY_LOANS": 69,
              "WELLS_DIGITAL_CHECKS": 70,
              "WELLS_CASH_INTEREST": 71,
              "JP_SMBC_CAPITAL": 72,
              "WELLS_ORDERS_PREFUNDING": 73,
              "WELLS_BILL_PAY": 74,
              "WELLS_AFTERPAY_PAYOUT": 75,
              "WELLS_CASH_ROA": 76,
              "WELLS_PLATFORM_EXPERIMENT": 77,
              "CA_CHASE_FOLDERS": 78,
              "WELLS_CASH_OVERDRAFT_FBO": 79,
              "WELLS_CASH_ITEM": 80,
              "WELLS_CASH_LENDING_ITEM": 81
            }
          },
          "TransactionBlocker": {
            "values": {
              "DEFAULT_DO_NOT_USE": 0,
              "BLACKLISTED": 1,
              "PERMANENTLY_FAILED": 3,
              "NOT_VERIFIED": 5
            }
          },
          "UsAccount": {
            "fields": {
              "routingNumber": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "CaAccount": {
            "fields": {
              "transitNumber": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "JpAccount": {
            "fields": {
              "bankCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "branchCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "AuAccount": {
            "fields": {
              "bsbNumber": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "GbAccountDetails": {
            "fields": {
              "supportsBacs": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "supportsDirectDebit": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "supportsFasterPayments": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "bic": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "GbAccount": {
            "fields": {
              "sortCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "accountDetails": {
                "type": "squareup.bank_accounts.GbAccountDetails",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "FrAccount": {
            "fields": {
              "bankCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "branchCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "swiftBic": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "IeAccount": {
            "fields": {
              "swiftBic": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "EsAccount": {
            "fields": {
              "swiftBic": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "SepaAccount": {
            "fields": {
              "swiftBic": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "MxAccount": {
            "fields": {
              "bankCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "branchCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "CountrySpecificDetail": {
            "fields": {
              "vaultedData": {
                "type": "squareup.privacyvault.VaultedData",
                "id": 7,
                "rule": "optional"
              },
              "usAccount": {
                "type": "squareup.bank_accounts.UsAccount",
                "id": 1
              },
              "caAccount": {
                "type": "squareup.bank_accounts.CaAccount",
                "id": 2
              },
              "jpAccount": {
                "type": "squareup.bank_accounts.JpAccount",
                "id": 3
              },
              "auAccount": {
                "type": "squareup.bank_accounts.AuAccount",
                "id": 4
              },
              "gbAccount": {
                "type": "squareup.bank_accounts.GbAccount",
                "id": 5
              },
              "frAccount": {
                "type": "squareup.bank_accounts.FrAccount",
                "id": 6
              },
              "ieAccount": {
                "type": "squareup.bank_accounts.IeAccount",
                "id": 8
              },
              "esAccount": {
                "type": "squareup.bank_accounts.EsAccount",
                "id": 9
              },
              "sepaAccount": {
                "type": "squareup.bank_accounts.SepaAccount",
                "id": 10
              },
              "mxAccount": {
                "type": "squareup.bank_accounts.MxAccount",
                "id": 11
              }
            },
            "nested": {
              "country_specific_detail": {
                "oneof": ["usAccount", "caAccount", "jpAccount", "auAccount", "gbAccount", "frAccount", "ieAccount", "esAccount", "sepaAccount", "mxAccount"]
              }
            }
          },
          "BankAccountSpec": {
            "fields": {
              "accountNumber": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "countryCode": {
                "type": "squareup.common.countries.Country",
                "id": 2,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 3,
                "rule": "optional"
              },
              "type": {
                "type": "squareup.bank_accounts.BankAccountType",
                "id": 4,
                "rule": "optional"
              },
              "accountHolderName": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "countrySpecificDetail": {
                "type": "squareup.bank_accounts.CountrySpecificDetail",
                "id": 6,
                "rule": "optional"
              },
              "bankbookFideliusToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "vaultedData": {
                "type": "squareup.privacyvault.VaultedData",
                "id": 8,
                "rule": "optional"
              },
              "debitMandateReferenceId": {
                "type": "int64",
                "id": 9,
                "rule": "optional"
              },
              "oauthApplicationId": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "platformAccountToken": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "overriddenAccountNumberSuffix": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              }
            }
          },
          "BankAccount": {
            "fields": {
              "token": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "accountNumberSuffix": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "countryCode": {
                "type": "squareup.common.countries.Country",
                "id": 2,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 3,
                "rule": "optional"
              },
              "type": {
                "type": "squareup.bank_accounts.BankAccountType",
                "id": 4,
                "rule": "optional"
              },
              "accountHolderName": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "countrySpecificDetail": {
                "type": "squareup.bank_accounts.CountrySpecificDetail",
                "id": 6,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.common.time.DateTime",
                "id": 7,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 8,
                "rule": "optional"
              },
              "deletedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 13,
                "rule": "optional"
              },
              "verificationStates": {
                "type": "squareup.bank_accounts.BankAccountVerificationStates",
                "id": 9,
                "rule": "optional"
              },
              "transactionBlocker": {
                "type": "squareup.bank_accounts.TransactionBlocker",
                "id": 11,
                "rule": "repeated"
              },
              "squareWebScope": {
                "type": "squareup.bank_accounts.BankAccount.SquareWebScope",
                "id": 12,
                "rule": "optional"
              },
              "bankCodeInfo": {
                "type": "squareup.bank_accounts.BankCodeInfo",
                "id": 14,
                "rule": "optional"
              },
              "vaultedData": {
                "type": "squareup.privacyvault.VaultedData",
                "id": 15,
                "rule": "optional"
              },
              "fingerprint": {
                "type": "string",
                "id": 16,
                "rule": "optional"
              },
              "externalVerificationState": {
                "type": "squareup.bank_accounts.BankAccount.ExternalVerificationState",
                "id": 17,
                "rule": "optional"
              },
              "bankCode": {
                "type": "string",
                "id": 18,
                "rule": "optional"
              },
              "version": {
                "type": "int32",
                "id": 19,
                "rule": "optional"
              },
              "fideliusToken": {
                "type": "string",
                "id": 20,
                "rule": "optional"
              },
              "debitMandateReferenceId": {
                "type": "string",
                "id": 21,
                "rule": "optional"
              },
              "clientMetadata": {
                "type": "string",
                "id": 22,
                "rule": "optional"
              },
              "clientToken": {
                "type": "string",
                "id": 23,
                "rule": "optional"
              },
              "clientMetadataVersion": {
                "type": "int64",
                "id": 24,
                "rule": "optional"
              },
              "isAccountNumberSuffixOverridden": {
                "type": "bool",
                "id": 25,
                "rule": "optional"
              },
              "riskFideliusToken": {
                "type": "string",
                "id": 26,
                "rule": "optional"
              },
              "deduplicationToken": {
                "type": "string",
                "id": 27,
                "rule": "optional"
              }
            },
            "nested": {
              "SquareWebBankAccountState": {
                "values": {
                  "DO_NOT_USE": 0,
                  "CREATED": 1,
                  "AWAITING_USER_APPROVAL": 2,
                  "RECEIVED_USER_APPROVAL": 3,
                  "AWAITING_DEBIT_AUTHORIZATION": 4,
                  "DEPOSITS_SENT": 5,
                  "UNVERIFIED_WITH_DEPOSITS_SENT": 6,
                  "DEPOSITS_PENDING": 7,
                  "UNVERIFIED_WITH_DEPOSITS_PENDING": 8,
                  "VERIFIED_WITH_DEPOSITS_PENDING": 9,
                  "VERIFIED": 10,
                  "VERIFIED_CREDIT_ONLY": 11,
                  "VERIFICATION_CANCELED": 12,
                  "FAILED": 13
                }
              },
              "SquareWebScope": {
                "fields": {
                  "squareWebBankAccountId": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "squareWebBankAccountState": {
                    "type": "squareup.bank_accounts.BankAccount.SquareWebBankAccountState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "verifiedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "squareWebBankAccountToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "userId": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "merchantCountryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 7,
                    "rule": "optional"
                  },
                  "verificationRequired": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "transactionFundId": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "denylisted": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "verificationDepositAmounts": {
                    "type": "int32",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "failureReason": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "changeConfirmationToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "verificationMethod": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "ExternalVerificationState": {
                "fields": {
                  "status": {
                    "type": "squareup.bank_accounts.BankAccount.ExternalVerificationState.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditable": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "debitable": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "VERIFICATION_IN_PROGRESS": 1,
                      "VERIFIED": 2,
                      "DISABLED": 3
                    }
                  }
                }
              }
            }
          },
          "BankAccountVerificationState": {
            "values": {
              "DO_NOT_USE": 0,
              "UNAVAILABLE": 1,
              "FAILED": 2,
              "VERIFIED": 3,
              "PENDING": 4,
              "UNVERIFIED": 5
            }
          },
          "BankAccountVerificationStateInfo": {
            "fields": {
              "verificationState": {
                "type": "squareup.bank_accounts.BankAccountVerificationState",
                "id": 1,
                "rule": "optional"
              },
              "unverifiedReason": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "verificationFinishedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "BankAccountVerificationStates": {
            "fields": {
              "creditOnly": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "statusVerificationStateInfo": {
                "type": "squareup.bank_accounts.BankAccountVerificationStateInfo",
                "id": 2,
                "rule": "optional"
              },
              "ownershipVerificationStateInfo": {
                "type": "squareup.bank_accounts.BankAccountVerificationStateInfo",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "BankCodeInfo": {
            "fields": {
              "name": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "alternativeName": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "branches": {
                "type": "squareup.bank_accounts.BranchCodeInfo",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "BranchCodeInfo": {
            "fields": {
              "name": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "alternativeName": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "blacklistedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "countrySpecificDetail": {
                "type": "squareup.bank_accounts.CountrySpecificDetail",
                "id": 4,
                "rule": "optional"
              },
              "previousCountrySpecificDetail": {
                "type": "squareup.bank_accounts.CountrySpecificDetail",
                "id": 5,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccountType && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.SquareBankAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.TransactionBlocker && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.UsAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.CaAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.JpAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.AuAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.GbAccountDetails && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.GbAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.FrAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.IeAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.EsAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.SepaAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.MxAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.CountrySpecificDetail && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccountSpec && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccount && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccount?.nested?.SquareWebBankAccountState && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccount?.nested?.SquareWebScope && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccount?.nested?.ExternalVerificationState && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccount?.nested?.ExternalVerificationState?.nested?.Status && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccountVerificationState && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccountVerificationStateInfo && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankAccountVerificationStates && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BankCodeInfo && !$root.nested?.squareup?.nested?.bank_accounts?.nested?.BranchCodeInfo) {
  $root.addJSON(jsonData);
}

/**
 * Types of bank accounts known at Square.
 *
 * SOURCE BankAccountType @ squareup/bank-accounts/bank_accounts.proto at 18:1
 */
export const BankAccountType = $root.lookupEnum('squareup.bank_accounts.BankAccountType').values;
/**
 * Square bank accounts
 *
 * SOURCE SquareBankAccount @ squareup/bank-accounts/bank_accounts.proto at 64:1
 */
export const SquareBankAccount = $root.lookupEnum('squareup.bank_accounts.SquareBankAccount').values;
/**
 * Reasons why a bank account is not transactable.
 *
 * SOURCE TransactionBlocker @ squareup/bank-accounts/bank_accounts.proto at 310:1
 */
export const TransactionBlocker = $root.lookupEnum('squareup.bank_accounts.TransactionBlocker').values;
/**
 * Bank account data specific to the U.S.
 *
 * SOURCE UsAccount @ squareup/bank-accounts/bank_accounts.proto at 329:1
 */
export const UsAccount = $root.lookupType('squareup.bank_accounts.UsAccount');
fixType(UsAccount, {
  routingNumber: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UsAccount);
/**
 * Bank account data specific to Canada.
 *
 * SOURCE CaAccount @ squareup/bank-accounts/bank_accounts.proto at 339:1
 */
export const CaAccount = $root.lookupType('squareup.bank_accounts.CaAccount');
fixType(CaAccount, {
  transitNumber: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CaAccount);
/**
 * Bank account data specific to Japan.
 *
 * SOURCE JpAccount @ squareup/bank-accounts/bank_accounts.proto at 349:1
 */
export const JpAccount = $root.lookupType('squareup.bank_accounts.JpAccount');
fixType(JpAccount, {
  bankCode: {
    notEmpty: true
  },
  branchCode: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(JpAccount);
/**
 * Bank account data specific to Australia.
 *
 * SOURCE AuAccount @ squareup/bank-accounts/bank_accounts.proto at 366:1
 */
export const AuAccount = $root.lookupType('squareup.bank_accounts.AuAccount');
fixType(AuAccount, {
  bsbNumber: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(AuAccount);
/**
 * SOURCE GbAccountDetails @ squareup/bank-accounts/bank_accounts.proto at 375:1
 */
export const GbAccountDetails = $root.lookupType('squareup.bank_accounts.GbAccountDetails');
fixType(GbAccountDetails, {
  supportsBacs: {
    required: true
  },
  supportsDirectDebit: {
    required: true
  },
  supportsFasterPayments: {
    required: true
  }
});
Builder.createAndAttachToType(GbAccountDetails);
/**
 * SOURCE GbAccount @ squareup/bank-accounts/bank_accounts.proto at 393:1
 */
export const GbAccount = $root.lookupType('squareup.bank_accounts.GbAccount');
fixType(GbAccount);
Builder.createAndAttachToType(GbAccount);
/**
 * SOURCE FrAccount @ squareup/bank-accounts/bank_accounts.proto at 405:1
 */
export const FrAccount = $root.lookupType('squareup.bank_accounts.FrAccount');
fixType(FrAccount, {
  swiftBic: {
    required: true
  }
});
Builder.createAndAttachToType(FrAccount);
/**
 * SOURCE IeAccount @ squareup/bank-accounts/bank_accounts.proto at 428:1
 */
export const IeAccount = $root.lookupType('squareup.bank_accounts.IeAccount');
fixType(IeAccount, {
  swiftBic: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(IeAccount);
/**
 * SOURCE EsAccount @ squareup/bank-accounts/bank_accounts.proto at 437:1
 */
export const EsAccount = $root.lookupType('squareup.bank_accounts.EsAccount');
fixType(EsAccount, {
  swiftBic: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(EsAccount);
/**
 * SOURCE SepaAccount @ squareup/bank-accounts/bank_accounts.proto at 446:1
 */
export const SepaAccount = $root.lookupType('squareup.bank_accounts.SepaAccount');
fixType(SepaAccount, {
  swiftBic: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SepaAccount);
/**
 * Bank account data specific to the Mexico.
 *
 * SOURCE MxAccount @ squareup/bank-accounts/bank_accounts.proto at 456:1
 */
export const MxAccount = $root.lookupType('squareup.bank_accounts.MxAccount');
fixType(MxAccount);
Builder.createAndAttachToType(MxAccount);
/**
 * Country-specific detail for a bank account.
 *
 * SOURCE CountrySpecificDetail @ squareup/bank-accounts/bank_accounts.proto at 471:1
 */
export const CountrySpecificDetail = $root.lookupType('squareup.bank_accounts.CountrySpecificDetail');
fixType(CountrySpecificDetail);
Builder.createAndAttachToType(CountrySpecificDetail);
/**
 * Specification for creating a new BankAccount.
 *
 * SOURCE BankAccountSpec @ squareup/bank-accounts/bank_accounts.proto at 510:1
 */
export const BankAccountSpec = $root.lookupType('squareup.bank_accounts.BankAccountSpec');
fixType(BankAccountSpec, {
  accountNumber: {
    notEmpty: true
  },
  countryCode: {
    required: true
  },
  currencyCode: {
    required: true
  },
  type: {
    required: true
  },
  accountHolderName: {
    notEmpty: true
  },
  countrySpecificDetail: {
    required: true
  }
});
Builder.createAndAttachToType(BankAccountSpec);
/**
 * A base model of a bank account.
 * For a simplified external representation see {@code ExternalBankAccount}.
 *
 * SOURCE BankAccount @ squareup/bank-accounts/bank_accounts.proto at 614:1
 */
export const BankAccount = $root.lookupType('squareup.bank_accounts.BankAccount');
fixType(BankAccount, {
  token: {
    notEmpty: true
  },
  accountNumberSuffix: {
    notEmpty: true
  },
  countryCode: {
    required: true
  },
  currencyCode: {
    required: true
  },
  type: {
    required: true
  },
  accountHolderName: {
    notEmpty: true
  },
  countrySpecificDetail: {
    required: true
  },
  createdAt: {
    required: true
  },
  updatedAt: {
    required: true
  }
});
Builder.createAndAttachToType(BankAccount);
/**
 * Square Web specific bank account states copied from VerificationState.java
 *
 * SOURCE SquareWebBankAccountState @ squareup/bank-accounts/bank_accounts.proto at 618:3
 */
BankAccount.SquareWebBankAccountState = $root.lookupEnum('squareup.bank_accounts.BankAccount.SquareWebBankAccountState').values;
/**
 * Data related to a bank account owned by Square Web.
 *
 * SOURCE SquareWebScope @ squareup/bank-accounts/bank_accounts.proto at 636:3
 */
BankAccount.SquareWebScope = $root.lookupType('squareup.bank_accounts.BankAccount.SquareWebScope');
fixType(BankAccount.SquareWebScope);
Builder.createAndAttachToType(BankAccount.SquareWebScope);
/**
 * Fields for the simplified verification state model we expose via our public bank account API.
 *
 * SOURCE ExternalVerificationState @ squareup/bank-accounts/bank_accounts.proto at 702:3
 */
BankAccount.ExternalVerificationState = $root.lookupType('squareup.bank_accounts.BankAccount.ExternalVerificationState');
fixType(BankAccount.ExternalVerificationState);
Builder.createAndAttachToType(BankAccount.ExternalVerificationState);
/**
 * SOURCE Status @ squareup/bank-accounts/bank_accounts.proto at 703:5
 */
BankAccount.ExternalVerificationState.Status = $root.lookupEnum('squareup.bank_accounts.BankAccount.ExternalVerificationState.Status').values;
/**
 * State representation of a bank verification.
 *
 * For bank account status, this is used to determine if a bank account
 * is open and whether it is transactable.
 *
 * For bank account ownership, this is used to determine if a bank account
 * is owned by the entity (e.g: a merchant) that is attempting to verify the account.
 *
 * SOURCE BankAccountVerificationState @ squareup/bank-accounts/bank_accounts.proto at 911:1
 */
export const BankAccountVerificationState = $root.lookupEnum('squareup.bank_accounts.BankAccountVerificationState').values;
/**
 * Detailed information regarding a bank account verification.
 *
 * SOURCE BankAccountVerificationStateInfo @ squareup/bank-accounts/bank_accounts.proto at 1024:1
 */
export const BankAccountVerificationStateInfo = $root.lookupType('squareup.bank_accounts.BankAccountVerificationStateInfo');
fixType(BankAccountVerificationStateInfo, {
  verificationState: {
    required: true
  }
});
Builder.createAndAttachToType(BankAccountVerificationStateInfo);
/**
 * A collection of states relating to verification of a bank account.
 *
 * SOURCE BankAccountVerificationStates @ squareup/bank-accounts/bank_accounts.proto at 1040:1
 */
export const BankAccountVerificationStates = $root.lookupType('squareup.bank_accounts.BankAccountVerificationStates');
fixType(BankAccountVerificationStates, {
  statusVerificationStateInfo: {
    required: true
  },
  ownershipVerificationStateInfo: {
    required: true
  }
});
Builder.createAndAttachToType(BankAccountVerificationStates);
/**
 * Information for a bank with a list of all available branches
 *
 * SOURCE BankCodeInfo @ squareup/bank-accounts/bank_accounts.proto at 1052:1
 */
export const BankCodeInfo = $root.lookupType('squareup.bank_accounts.BankCodeInfo');
fixType(BankCodeInfo);
Builder.createAndAttachToType(BankCodeInfo);
/**
 * Detailed information about a particular bank code (e.g., routing number, BSB number).
 *
 * SOURCE BranchCodeInfo @ squareup/bank-accounts/bank_accounts.proto at 1064:1
 */
export const BranchCodeInfo = $root.lookupType('squareup.bank_accounts.BranchCodeInfo');
fixType(BranchCodeInfo);
Builder.createAndAttachToType(BranchCodeInfo);